// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".A-root__L3Zlc {\n  color: black;\n  font-weight: 400;\n  position: relative;\n\n  text-decoration: underline;\n  text-underline-position: under;\n}\n", "",{"version":3,"sources":["webpack://./../ui/components/Content/A.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;;EAElB,0BAA0B;EAC1B,8BAA8B;AAChC","sourcesContent":[".root {\n  color: black;\n  font-weight: 400;\n  position: relative;\n\n  text-decoration: underline;\n  text-underline-position: under;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "A-root__L3Zlc"
};
export default ___CSS_LOADER_EXPORT___;
